<template>
  <div>
    <div class="services">
      <draggable :value="value" @input="$emit('input', $event)">
        <transition-group>
          <div class="service" v-for="service in value" :key="service.uuid">
            <button class="remove" @click="remove(service.uuid)">
              <i class="material-icons">close</i>
            </button>
            <div class="icon">
              <img :src="service.icon" :alt="service.name">
            </div>
            <div class="name">{{ service.name }}</div>
          </div>
        </transition-group>
      </draggable>
      <button class="add" type="button" @click="show = true">Добавить услугу</button>
    </div>
    <Dialog v-model="show">
      <div class="service-dialog">
        <div class="header">
          <FormField class="form-field">
            <Input v-model="name" placeholder="Название услуги..." />
          </FormField>
          <button @click="add" :disabled="!(selectIcon && name)">Добавить</button>
        </div>
        <div class="label">Выберите иконку: </div>
        <div class="icons">
          <div v-for="icon in icons" :key="icon"
            @click="selectIcon = icon"
            class="icon"
            :class="{ 'selected-icon': selectIcon === icon }">
            <img :src="icon">
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Dialog from '@app/components/uikit/Dialog';
import Input from '@app/components/uikit/Input';
import FormField from '@app/components/uikit/FormField';

import ElectrocardiogramSvg from '@app/assets/electrocardiogram.svg';
import ResonanceSvg from '@app/assets/resonance.svg';
import SonographySvg from '@app/assets/sonography.svg';
import XRaySvg from '@app/assets/x-ray.svg';

import Icon1 from '@app/assets/medical-icons/blood-cell.svg';
import Icon2 from '@app/assets/medical-icons/dental-care.svg';
import Icon3 from '@app/assets/medical-icons/eye-test.svg';
import Icon4 from '@app/assets/medical-icons/flea.svg';
import Icon5 from '@app/assets/medical-icons/injection.svg';
import Icon6 from '@app/assets/medical-icons/stethoscope.svg';
import Icon7 from '@app/assets/medical-icons/stethoscope-pet.svg';
import Icon8 from '@app/assets/medical-icons/vaccine.svg';
import Icon9 from '@app/assets/medical-icons/veterinary.svg';
import Icon10 from '@app/assets/medical-icons/ear.svg';
import Icon11 from '@app/assets/medical-icons/bone.svg';
import Icon12 from '@app/assets/medical-icons/stomach.svg';
import Icon13 from '@app/assets/medical-icons/blood-transfusion.svg';
import Icon14 from '@app/assets/medical-icons/kidneys.svg';
import Icon15 from '@app/assets/medical-icons/child.svg';
import Icon16 from '@app/assets/medical-icons/backbone.svg';
import Icon17 from '@app/assets/medical-icons/brain.svg';

import { v4 as uuidv4 } from 'uuid';


export default {
  props: {
    value: Array,
  },
  components: {
    draggable,
    Dialog,
    Input,
    FormField,
  },
  data: () => ({
    show: false,
    name: null,
    selectIcon: null,
    icons: [
      ElectrocardiogramSvg,
      ResonanceSvg,
      SonographySvg,
      XRaySvg,
      Icon1,
      Icon2,
      Icon3,
      Icon4,
      Icon5,
      Icon6,
      Icon7,
      Icon8,
      Icon9,
      Icon10,
      Icon11,
      Icon12,
      Icon13,
      Icon14,
      Icon15,
      Icon16,
      Icon17,
    ]
  }),
  methods: {
    remove(uuid) {
      this.$emit('remove', uuid);
    },
    add() {
      const uuid = uuidv4();
      const payload = {
        uuid,
        icon: this.selectIcon,
        name: this.name,
      };
      this.$emit('add', payload);
      this.close();
    },
    close() {
      this.show = false;
      this.selectIcon = null;
      this.name = null;
    }
  }
};
</script>

<style scoped>
.sortable-ghost {
  opacity: .33;
}
.services {
  background-color: #f2f2f2;
  border-radius: 4px;
  overflow: hidden;
  padding: 1rem;
  margin-bottom: 24px;
}
.services > div > span {
  display: flex;
  flex-wrap: wrap;
}
.service {
  position: relative;
  display: flex;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 10px 2px rgb(0 0 0 / 10%);
  width: 11rem;
  height: 4rem;
  align-items: center;
  margin-right: 12px;
  margin-bottom: 12px;
}
.service .remove {
  position: absolute;
  top: -6px;
  right: -6px;
  outline: 0;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ff6a6a;
}
.service .remove:hover {
  background-color: #dd6969;
}
.service .remove i {
  font-size: 16px;
  color: #fff;
}
.service .icon {
  padding: 0 12px;
}
.service img {
  width: 32px;
}
.service .name {
  font-weight: 300;
  color: #424242;
  font-size: 14px;
}
.services button.add {
  border: 1px dashed #9b9b9b;
  border-radius: 4px;
  transition: background-color 300ms ease;
  color: #9b9b9b;
  width: 11rem;
  height: 4rem;
  outline: 0;
}
button:hover {
  background-color: #ececec;
}
.label {
  padding-left: 6px;
  font-weight: 300;
  color: rgb(94, 94, 94);
}
.service-dialog {
  padding: 18px;
}
.service-dialog .header {
  display: flex;
  padding: 6px;
  padding-bottom: 0;
}
.service-dialog .header .form-field {
  width: 400px;
}
.service-dialog .header button {
  border-radius: 4px;
  height: 36px;
  padding: 0 12px;
  outline: 0;
  margin-bottom: 24px;
  margin-left: 12px;
  background-color: rgb(140, 48, 218);
  color: #fff;
  font-weight: 300;
}
.service-dialog .header button:disabled {
  opacity: .3;
}
.service-dialog .icons {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  width: 520px;
}
.service-dialog .icons .icon {
  cursor: pointer;
  display: flex;
  flex: 0 0 62px;
  height: 62px;
  justify-content: center;
  border-radius: 4px;
  margin: 6px;
}
.service-dialog .icons .icon.selected-icon {
  border: 1px solid rgb(140, 48, 218);
}
.service-dialog .icons img {
  width: 36px;
}
</style>
